var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal-component",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShow,
          expression: "isShow"
        }
      ],
      on: {
        modalOk: _vm.onOk,
        modalNo: _vm.onClose,
        afterLeave: _vm.onAfterLeave
      }
    },
    [
      _c("h4", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _vm._v(" "),
      _c(
        "h3",
        {
          staticStyle: { "text-align": "center" },
          attrs: { slot: "body" },
          slot: "body"
        },
        [
          _c(
            "p",
            { staticClass: "tc pb2em", staticStyle: { "margin-top": "0.5em" } },
            [_c("strong", [_vm._v(_vm._s(_vm.message))])]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }